import moment from 'moment';
import Component from '../../components/Component';
import Loading from '../../components/Loading';
import AlgoDateRangePickerContainer from '../../components/Modals/AlgoDatePicker';
import ReportComparisonItems from './items';
import { query } from './query';
import CHOICES from '../Filters/Choices/Dates';
import getDataRange from '../../helpers/getDataRange';
import { withTranslation } from 'react-i18next';

class AlgoComparison extends Component {
    constructor() {
        super();
        this.query = query;

        this.handleDisable = this.handleDisable.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.showContent = this.showContent.bind(this);
        this.setDates = this.setDates.bind(this);
        this.updateStart = this.updateStart.bind(this);
        this.updateEnd = this.updateEnd.bind(this);
        this.onApply = this.onApply.bind(this);
        this.getFirstMaxDate = this.getFirstMaxDate.bind(this);
        this.getLastMinDate = this.getLastMinDate.bind(this);
        this.selectRange = this.selectRange.bind(this);
        this.emptyRange = this.emptyRange.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            !!this.state.data &&
            this.state.data.length !== 0 &&
            JSON.stringify(prevState.data) !== JSON.stringify(this.state.data)
        ) {
            const now = moment();

            const mindate = this.state.data?.[0]?.mindate?.value;
            const maxdate = this.state.data?.[0]?.maxdate?.value;
            if (!mindate || !maxdate) return;
            const formatedMinDate = moment(mindate, 'YYYY-MM-DD');
            const formatedMaxDate = moment(maxdate, 'YYYY-MM-DD');
            const dayDifference = Math.abs(formatedMinDate.clone().diff(now, 'days'));

            const toWeekStart =
                dayDifference >= 20
                    ? formatedMaxDate.clone().subtract(6, 'days').format('YYYY-MM-DD')
                    : formatedMaxDate.clone().subtract(1, 'days').format('YYYY-MM-DD');
            const toWeekEnd = formatedMaxDate.clone().format('YYYY-MM-DD');
            const fromWeekStart =
                dayDifference >= 20
                    ? formatedMaxDate.clone().subtract(20, 'days').format('YYYY-MM-DD')
                    : formatedMaxDate.clone().subtract(3, 'days').format('YYYY-MM-DD');
            const fromWeekEnd =
                dayDifference >= 20
                    ? formatedMaxDate.clone().subtract(14, 'days').format('YYYY-MM-DD')
                    : formatedMaxDate.clone().subtract(2, 'days').format('YYYY-MM-DD');

            const dates = {
                fromEnd: fromWeekEnd,
                fromStart: fromWeekStart,
                toStart: toWeekStart,
                toEnd: toWeekEnd,
            };

            const start_date = {
                start_date: fromWeekStart,
                end_date: fromWeekEnd,
            };

            const end_date = {
                start_date: toWeekStart,
                end_date: toWeekEnd,
            };
            this.setState({ end_date, start_date, appliedDates: dates });
        }
    }

    handleChange(type, value) {
        this.setState({
            [type]: value,
        });
    }

    setDates() {
        const dates = {
            fromEnd: this.state.fromEnd,
            fromStart: this.state.fromStart,
            toStart: this.state.toStart,
            toEnd: this.state.toEnd,
        };
        this.setState({ appliedDates: dates });
    }

    showContent() {
        const { appliedDates } = this.state;
        if (!appliedDates) return false;

        for (let key in appliedDates) {
            if (!appliedDates[key]) return false;
        }

        return true;
    }

    handleDisable() {
        if (!this.state?.start_date || !this.state?.end_date) return true;
        const { start_date, end_date } = this.state?.start_date;
        const { start_date: end_tart_date, end_date: end_end_date } = this.state?.end_date;

        const condition =
            !start_date ||
            !end_date ||
            !end_tart_date ||
            !end_end_date ||
            new Date(start_date) > new Date(end_date) ||
            new Date(end_tart_date) <= new Date(end_date) ||
            new Date(end_tart_date) > new Date(end_end_date);

        if (condition) return true;

        return false;
    }

    updateStart(date) {
        if (this.state.fromRange) {
            this.setState({
                end_date: this.state.fromRange.end_date,
            });
        }
        this.setState({
            start_date: date,
        });
    }
    updateEnd(date) {
        if (this.state.fromRange) {
            this.setState({
                start_date: this.state.fromRange.start_date,
            });
        }
        this.setState({
            end_date: date,
        });
    }

    onApply() {
        const appliedDates = {
            fromStart: this.state?.start_date?.start_date,
            fromEnd: this.state?.start_date?.end_date,
            toStart: this.state?.end_date?.start_date,
            toEnd: this.state?.end_date?.end_date,
        };

        this.setState({
            appliedDates,
        });
    }

    getFirstMaxDate() {
        if (this.state?.end_date?.start_date)
            return moment(this.state?.end_date?.start_date)
                .subtract(1, 'days')
                .format('YYYY-MM-DD');

        return this.state.data?.[0]?.maxdate?.value;
    }

    getLastMinDate() {
        if (this.state?.start_date?.end_date)
            return moment(this.state?.start_date?.end_date).add(1, 'days').format('YYYY-MM-DD');

        return this.state.data?.[0]?.minDate?.value;
    }

    selectRange(key, range) {
        const { start_date, end_date } = getDataRange(range, true);
        const diff = Math.abs(
            moment(end_date?.value).clone().diff(moment(start_date?.value), 'days'),
        );

        const firstLastDate = moment(start_date?.value)?.clone()?.subtract(1, 'days');
        const firstFirstDate = moment(firstLastDate)?.clone()?.subtract(diff, 'days');

        this.setState({
            fromRange: {
                start_date: {
                    start_date: firstFirstDate.format('YYYY-MM-DD'),
                    end_date: firstLastDate.format('YYYY-MM-DD'),
                },
                end_date: {
                    start_date: start_date?.value,
                    end_date: end_date?.value,
                },
            },
        });

        if (key === 'start') {
            return {
                start_date: firstFirstDate.format('YYYY-MM-DD'),
                end_date: firstLastDate.format('YYYY-MM-DD'),
            };
        } else {
            return {
                start_date: start_date?.value,
                end_date: end_date?.value,
            };
        }
    }

    emptyRange() {
        this.setState({
            fromRange: null,
        });
    }

    render() {
        if (!this.state.data) return <Loading />;
        const { t } = this.props;
        const { appliedDates } = this.state;
        const disableAllowBtn = this.handleDisable();

        const firstMinDate = this.state.data?.[0]?.mindate?.value;
        const firstMaxDate = this.getFirstMaxDate();
        const lastMinDate = this.getLastMinDate();
        const lastMaxDate = this.state.data?.[0]?.maxdate?.value;

        return (
            <>
                <div
                    className={
                        (this.props.className || '') + ' dropdown list-group-item-action mb-10'
                    }
                    style={{
                        zIndex: 4,
                    }}
                >
                    <div className="card overflow-hidden">
                        <div className="card-body algo-time-container">
                            <div>
                                <div className="algo-time-container-header">
                                    {t('discover.algo_comparision.period.header')}
                                </div>
                                <div className="algo-time-container-subtitle">
                                    {t('discover.algo_comparision.period.subheader')}
                                </div>
                            </div>
                            <div className="algo-time-container-right">
                                <AlgoDateRangePickerContainer
                                    dateRange={this.state.data}
                                    updateSelect={this.updateEnd}
                                    header={t(
                                        'discover.algo_comparision.period.current_datepicker.header',
                                    )}
                                    values={this.state.end_date}
                                    minDate={lastMinDate}
                                    maxDate={lastMaxDate}
                                    options={CHOICES}
                                    emptyRange={this.emptyRange}
                                    selectRange={(range) => this.selectRange('end', range)}
                                />
                                vs
                                <AlgoDateRangePickerContainer
                                    dateRange={this.state.data}
                                    updateSelect={this.updateStart}
                                    header={t(
                                        'discover.algo_comparision.period.previous_datepicker.header',
                                    )}
                                    values={this.state.start_date}
                                    minDate={firstMinDate}
                                    maxDate={firstMaxDate}
                                    emptyRange={this.emptyRange}
                                    selectRange={(range) => this.selectRange('start', range)}
                                />
                                <button
                                    className="button button-primary button-filled"
                                    onClick={this.onApply}
                                    disabled={disableAllowBtn}
                                >
                                    {t('discover.algo_comparision.period.apply')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {this.showContent() && (
                    <ReportComparisonItems
                        author_message={this.props.author_message}
                        is_authors_disabled={this.props.is_authors_disabled}
                        dates={appliedDates}
                    />
                )}
            </>
        );
    }
}

export default withTranslation()(AlgoComparison);
